var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#4D9F6F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1706 6.38225C10.1706 5.35889 8.58357 4.5293 6.62584 4.5293C4.66811 4.5293 3.08105 5.35889 3.08105 6.38225M10.1706 6.38225C10.1706 7.15303 9.2703 7.81389 7.98938 8.09315M10.1706 6.38225V6.95876M3.08105 6.38225V8.21013C3.08105 8.98091 3.98138 9.64177 5.26229 9.92103M3.08105 6.38225C3.08105 7.15303 3.98138 7.81389 5.26229 8.09315M5.26229 8.09315C5.68204 8.18466 6.14265 8.2352 6.62584 8.2352C7.10903 8.2352 7.56964 8.18466 7.98938 8.09315M5.26229 8.09315V9.92103M5.26229 9.92103C5.444 9.96064 5.63336 9.99258 5.8289 10.0161M7.98938 8.09315V9.92103M7.98938 9.92103C9.2703 9.64177 10.1706 8.98091 10.1706 8.21013V6.95876M7.98938 9.92103C7.63167 9.99902 7.24428 10.0472 6.83852 10.0598M12.9185 8.7647V10.6176C12.9185 11.3884 12.0181 12.0493 10.7372 12.3285M12.9185 8.7647C12.9185 9.53547 12.0181 10.1963 10.7372 10.4756M12.9185 8.7647C12.9185 7.88458 11.7446 7.14778 10.1706 6.95876M8.01014 10.4756C8.42988 10.5671 8.89049 10.6176 9.37368 10.6176C9.85688 10.6176 10.3175 10.5671 10.7372 10.4756M8.01014 10.4756V12.3285M8.01014 10.4756C7.56683 10.3789 7.16911 10.2366 6.83852 10.0598M8.01014 12.3285C8.42988 12.4201 8.89049 12.4706 9.37368 12.4706C9.85688 12.4706 10.3175 12.4201 10.7372 12.3285M8.01014 12.3285C6.72922 12.0493 5.8289 11.3884 5.8289 10.6176V10.0161M10.7372 10.4756V12.3285M6.83852 10.0598C6.76816 10.062 6.69725 10.0631 6.62584 10.0631C6.35182 10.0631 6.08506 10.0468 5.8289 10.0161",
    stroke: "white",
    strokeWidth: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCost);
export default __webpack_public_path__ + "static/media/cost.1d07fa499202cc70e00a9ee2a1a74f93.svg";
export { ForwardRef as ReactComponent };